import React, { useState } from 'react';
import { Lock } from 'lucide-react';
import { useToast } from '../../../../../components/common/Toast';
import { useAccessTheme } from '../useAccessTheme';
import IdentityProviderModalShell from './IdentityProviderModalShell';
import { DEMO_SETUP_MESSAGE } from './identityProviderTypes';

interface SamlSetupModalProps {
  onClose: () => void;
}

const SamlSetupModal: React.FC<SamlSetupModalProps> = ({ onClose }) => {
  const t = useAccessTheme();
  const { showToast } = useToast();
  const [form, setForm] = useState({
    providerName: '',
    entityId: '',
    ssoUrl: '',
    certificate: '',
  });

  const labelCls = 'block text-xs font-medium mb-1 ' + t.muted;
  const inputCls = 'w-full border rounded-lg px-3 py-2 text-sm outline-none ' + t.input;

  return (
    <IdentityProviderModalShell
      title="Configure SAML 2.0"
      icon={<Lock className="w-5 h-5" />}
      onClose={onClose}
      footer={
        <button
          type="button"
          onClick={() => showToast({ type: 'info', message: DEMO_SETUP_MESSAGE })}
          className={'px-4 py-2 rounded-lg text-sm font-medium ' + t.btnPrimary}
        >
          Save Configuration
        </button>
      }
    >
      <div>
        <label className={labelCls}>Provider Name</label>
        <input
          type="text"
          value={form.providerName}
          onChange={(e) => setForm((prev) => ({ ...prev, providerName: e.target.value }))}
          className={inputCls}
          placeholder="e.g. Corporate SAML"
        />
      </div>
      <div>
        <label className={labelCls}>Entity ID</label>
        <input
          type="text"
          value={form.entityId}
          onChange={(e) => setForm((prev) => ({ ...prev, entityId: e.target.value }))}
          className={inputCls}
          placeholder="https://idp.example.com/entity"
        />
      </div>
      <div>
        <label className={labelCls}>SSO URL</label>
        <input
          type="text"
          value={form.ssoUrl}
          onChange={(e) => setForm((prev) => ({ ...prev, ssoUrl: e.target.value }))}
          className={inputCls}
          placeholder="https://idp.example.com/sso"
        />
      </div>
      <div>
        <label className={labelCls}>Certificate</label>
        <textarea
          value={form.certificate}
          onChange={(e) => setForm((prev) => ({ ...prev, certificate: e.target.value }))}
          rows={4}
          className={inputCls + ' resize-none font-mono'}
          placeholder="-----BEGIN CERTIFICATE-----"
        />
      </div>
    </IdentityProviderModalShell>
  );
};

export default SamlSetupModal;
